export function ofsaHeaderImageSwitcher() {
	'use strict';

	const wrappers = document.querySelectorAll( '.header-img-wrap' );

	wrappers.forEach( ( wrap ) => {
		const images = wrap.querySelectorAll( '.header-img' );

		// Need at least 2 images to switch; primary already has is-active from PHP.
		if ( images.length < 2 ) {
			return;
		}

		let current = 0;

		setInterval( () => {
			const next = ( current + 1 ) % images.length;
			const leaving = images[ current ];
			const entering = images[ next ];

			leaving.classList.remove( 'is-active' );
			leaving.classList.add( 'is-leaving' );
			entering.classList.add( 'is-active' );

			// After the transition ends, snap the leaving image back to "below"
			// without animating through the visible area.
			setTimeout( () => {
				leaving.style.transition = 'none';
				leaving.classList.remove( 'is-leaving' );
				// Force reflow so the instant position change is painted before
				// the transition is re-enabled.
				void leaving.offsetHeight;
				leaving.style.transition = '';
			}, 700 ); // match CSS transition duration

			current = next;
		}, 2500 );
	} );
}
